import CustomForm from '../../lib/FormValidator/Form/CustomForm';
import { Categoria } from '../../system/Categoria/Categoria';
import { Division } from '../../system/Division/Division';
import { TorneoOfflineAssertions } from '../../system/PlanillaPartidoOffline/TorneoOfflineAssertions';
import { Torneo } from '../../system/Torneo/Torneo';

class TorneoOfflineForm extends CustomForm {
  protected constructor(
    toro_id: string | null,
    toro_nombre: string,
    toro_cat: string,
    toro_div: string,
    toro_rama: string,
    toro_cant_per: number | null,
    toro_dur_per: number | null,
    toro_emp: boolean,
    toro_cant_te: number | null,
    toro_dur_te: number | null
  ) {
    const toroff = TorneoOfflineAssertions.build();
    super('TorneoOffline', toroff);
    this.addInputAsserted('toro_id', toro_id);
    this.addInput('toro_nombre', toro_nombre);
    this.addInput('toro_cat', toro_cat);
    this.addInput('toro_div', toro_div);
    this.addInput('toro_rama', toro_rama);
    this.addInput('toro_cant_per', toro_cant_per);
    this.addInput('toro_dur_per', toro_dur_per);
    this.addInput('toro_emp', toro_emp);
    this.addInput('toro_cant_te', toro_cant_te);
    this.addInput('toro_dur_te', toro_dur_te);
  }

  private static build(
    toro_id: string | null,
    toro_nombre: string,
    toro_cat: string,
    toro_div: string,
    toro_rama: string,
    toro_cant_per: number | null,
    toro_dur_per: number | null,
    toro_emp: boolean,
    toro_cant_te: number | null,
    toro_dur_te: number | null
  ) {
    return new this(
      toro_id,
      toro_nombre,
      toro_cat,
      toro_div,
      toro_rama,
      toro_cant_per,
      toro_dur_per,
      toro_emp,
      toro_cant_te,
      toro_dur_te
    );
  }

  static initialize() {
    return this.build(null, '', '', '', '', null, null, true, null, null);
  }

  toTorneo(): Torneo {
    return Torneo.createFrom(
      this.getIdInput().getValue(),
      this.getNombreInput().getValue(),
      new Date(),
      0,
      0,
      0,
      this.getRamaInput().getValue(),
      0,
      0,
      '',
      0,
      0,
      false,
      false,
      false,
      0,
      false,
      [],
      [],
      // Categoria
      Categoria.createFrom(
        null,
        this.getCatInput().getValue(),
        0,
        0,
        this.getDurPerInput().getValue(),
        this.getCantPerInput().getValue(),
        this.getCantTeInput().getValue(),
        this.getDurTeInput().getValue(),
        true,
        '',
        false
      ),
      // Division
      Division.createFrom(
        null,
        this.getDivInput().getValue(),
        '',
        true,
        true,
        0,
        '',
        '',
        this.getRamaInput().getValue(),
        '',
        []
      ),
      null,
      null,
      null
    );
  }

  getIdInput() {
    return this.getInputByName('toro_id');
  }

  getNombreInput() {
    return this.getInputByName('toro_nombre');
  }

  getCatInput() {
    return this.getInputByName('toro_cat');
  }

  getDivInput() {
    return this.getInputByName('toro_div');
  }

  getRamaInput() {
    return this.getInputByName('toro_rama');
  }

  getCantPerInput() {
    return this.getInputByName('toro_cant_per');
  }

  getDurPerInput() {
    return this.getInputByName('toro_dur_per');
  }

  getEmpInput() {
    return this.getInputByName('toro_emp');
  }

  getCantTeInput() {
    return this.getInputByName('toro_cant_te');
  }

  getDurTeInput() {
    return this.getInputByName('toro_dur_te');
  }
}

export default TorneoOfflineForm;
